import { render, staticRenderFns } from "./StripeFormHeader.vue?vue&type=template&id=71fff9ae&scoped=true&"
import script from "./StripeFormHeader.vue?vue&type=script&lang=js&"
export * from "./StripeFormHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71fff9ae",
  null
  
)

export default component.exports